export const PRODUCT_STATUS = [
  {
    value: '',
    label: 'Tất cả',
  },
  {
    value: 'active',
    label: 'Đang hoạt động',
  },
  {
    value: 'inactive',
    label: 'Dừng hoạt động',
  },
];

export const PRODUCT_POF_STATUS = [
  {
    value: '',
    label: 'Tất cả',
  },
  {
    value: 'suggest',
    label: 'Khuyến nghị',
  },
  {
    value: 'trial',
    label: 'Hàng mới',
  },
  {
    value: 'reorder',
    label: 'Tái đặt',
  },
  {
    value: 'other',
    label: 'Ngoài danh mục',
  },
  {
    value: 'reorder3',
    label: 'Tái đặt 3',
  },
];
